<template>
  <footer class="footer-bar">
    <div class="footer-content">
      <div class="footer-column footer-about">
        <div class="footer-logo-container">
          <img src="@/assets/logo.png" alt="格瑞创新 Logo" class="footer-logo" />
        </div>
        <p class="footer-desc">格瑞创新动漫平台，致力于为广大漫画爱好者提供优质的漫画阅读与创作服务。汇聚海量正版漫画资源，支持原创作者投稿，打造国内领先的网络动漫平台。</p>
      </div>
      <div class="footer-column">
        <h4>浏览发现</h4>
        <ul>
          <li><router-link to="/">首页推荐</router-link></li>
          <li><router-link to="/category">分类频道</router-link></li>
          <li><router-link to="/ranking">排行榜</router-link></li>
          <li><router-link to="/update">今日更新</router-link></li>
          <li><router-link to="/submission">创作者投稿</router-link></li>
        </ul>
      </div>
      <div class="footer-column">
        <h4>会员服务</h4>
        <ul>
          <li><router-link to="/vip">开通VIP</router-link></li>
          <li><router-link to="/coins">金币充值</router-link></li>
          <li><router-link to="/vip">VIP特权说明</router-link></li>
          <li><router-link to="/help">帮助中心</router-link></li>
        </ul>
      </div>
      <div class="footer-column">
        <h4>政策与协议</h4>
        <ul>
          <li>
            <router-link to="/minor-protection" class="minor-highlight">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="M9 12l2 2 4-4"/></svg>
              未成年人保护
            </router-link>
          </li>
          <li><router-link to="/agreement">用户协议</router-link></li>
          <li><router-link to="/privacy">隐私政策</router-link></li>
          <li><router-link to="/about">关于我们</router-link></li>
          <li><router-link to="/contact">联系我们</router-link></li>
          <li><router-link to="/copyright">版权声明</router-link></li>
        </ul>
      </div>
      <div class="footer-column footer-contact">
        <h4>联系方式</h4>
        <p><span class="contact-label">地址：</span>北京市朝阳区北辰东路8号院16号楼4层A406</p>
        <p><span class="contact-label">电话：</span>13810795803</p>
        <p><span class="contact-label">客服时间：</span>工作日 9:00 - 18:00</p>
      </div>
    </div>
    <div class="footer-bottom">
      <div class="footer-bottom-links">
        <router-link to="/minor-protection" class="minor-highlight">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="M9 12l2 2 4-4"/></svg>
          未成年人保护
        </router-link>
        <span class="divider">|</span>
        <router-link to="/agreement">用户协议</router-link>
        <span class="divider">|</span>
        <router-link to="/privacy">隐私政策</router-link>
        <span class="divider">|</span>
        <router-link to="/about">关于我们</router-link>
        <span class="divider">|</span>
        <router-link to="/contact">联系我们</router-link>
        <span class="divider">|</span>
        <router-link to="/help">帮助中心</router-link>
      </div>
      <p>© 2026 北京格瑞创新科技有限公司 保留所有权利</p>
      <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer" class="icp-link">
        京ICP备18005868号-3
      </a>
      <p class="footer-safety">违法和不良信息举报：12377.cn</p>
    </div>
  </footer>
</template>
<style scoped>
.footer-bar {
  background: #0f1923;
  border-top: 1px solid rgba(96, 165, 250, 0.12);
  color: #c8d6e5;
  font-size: 14px;
  margin-top: 60px;
  padding-top: 0;
}
.footer-content {
  display: flex;
  justify-content: space-between;
  max-width: 1200px;
  margin: 0 auto;
  padding: 48px 20px 32px;
  flex-wrap: wrap;
  gap: 36px;
}
.footer-column {
  flex: 1 1 180px;
  min-width: 160px;
}
.footer-about {
  flex: 1 1 280px;
}
.footer-logo-container {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 16px;
}
.footer-logo {
  width: 140px;
  height: auto;
  border-radius: 6px;
}
.footer-desc {
  color: #8899aa;
  font-size: 13px;
  line-height: 1.8;
  margin-bottom: 16px;
}
.footer-column h4 {
  font-size: 15px;
  font-weight: 600;
  color: #e8f4fc;
  margin-bottom: 16px;
  position: relative;
  padding-bottom: 8px;
}
.footer-column h4::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 28px;
  height: 2px;
  background: var(--brand);
  border-radius: 2px;
}
.footer-column ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.footer-column li {
  margin-bottom: 10px;
}
.footer-column a {
  color: #8899aa;
  text-decoration: none;
  transition: all 0.2s;
  font-size: 13px;
}
.footer-column a:hover {
  color: var(--brand);
  padding-left: 4px;
}
.footer-contact p {
  font-size: 13px;
  color: #8899aa;
  margin-bottom: 8px;
  line-height: 1.6;
}
.contact-label {
  color: #8899aa;
}
.footer-bottom {
  text-align: center;
  color: #6b7a8a;
  font-size: 12px;
  padding: 20px 20px 24px;
  border-top: 1px solid rgba(96, 165, 250, 0.08);
  background: #0c141c;
}
.footer-bottom-links {
  margin-bottom: 12px;
  display: flex;
  justify-content: center;
  gap: 8px;
  flex-wrap: wrap;
}
.footer-bottom-links a {
  color: #6b7a8a;
  text-decoration: none;
  font-size: 12px;
  transition: color 0.2s;
}
.footer-bottom-links a:hover {
  color: var(--brand);
}

/* 未成年人保护显眼入口 */
.minor-highlight {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--brand) !important;
  font-weight: 700;
}

.footer-column .minor-highlight svg,
.footer-bottom-links .minor-highlight svg {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
}

.footer-column .minor-highlight {
  font-size: 13px;
}

.footer-column .minor-highlight:hover {
  padding-left: 4px;
}
.divider {
  color: #3a4a5a;
  font-size: 12px;
}
.footer-bottom p {
  margin: 6px 0;
}
.icp-link {
  color: #5a6a7a;
  text-decoration: none;
  font-size: 12px;
  display: inline-block;
  margin-top: 6px;
  transition: color 0.2s;
}
.icp-link:hover {
  color: var(--brand);
  text-decoration: underline;
}
.footer-safety {
  margin-top: 10px;
  font-size: 11px;
  color: #4a5a6a;
}
@media (max-width: 900px) {
  .footer-content {
    flex-direction: column;
    gap: 28px;
    padding: 32px 20px 24px;
  }
  .footer-column {
    flex: 1 1 auto;
    min-width: auto;
  }
}
</style> 